export const CREATING_DEPARTURE = "CREATING_DEPARTURE";
export const UPDATING_DEPARTURE = "UPDATING_DEPARTURE";
export const DEPARTURE_CREATED = "DEPARTURE_CREATED";
export const DEPARTURE_UPDATED = "DEPARTURE_UPDATED";
export const ERROR_DEPARTURE_CREATE = "ERROR_DEPARTURE_CREATE";
export const ERROR_DEPARTURE_UPDATE = "ERROR_DEPARTURE_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
